import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import FilterBar from '../../../../components/filter-bar';
import { criteriaOperatorsMap } from '../../../../containers/base-filter-bar-container/criteria-operators';
import { FIRST_PAGE } from '../../../../services/pagination-service';
import { getFreightGridRequest, setFreightGridFilters } from '../../../../store/ltl/grid/ltl.grid.actions';
import { allFilterBys } from './filters';
import staticCriteriaArguments from './filters/static-criteria-arguments';
import { type AppliedFilter, mapFreightFiltersToApiParams } from './map-freight-filters-to-api-params';

import style from './freight-filter-bar.module.less';

export const FreightFilterBar = () => {
  const dispatch = useDispatch();
  const [appliedFilters, setAppliedFilters] = useState<AppliedFilter[]>([]);

  const onFiltersChanged = useCallback(
    (newFilters: AppliedFilter[]) => {
      setAppliedFilters(newFilters);
      const apiParams = mapFreightFiltersToApiParams(newFilters);
      dispatch(setFreightGridFilters(apiParams));
      dispatch(getFreightGridRequest(FIRST_PAGE));
    },
    [dispatch],
  );

  const clearFilters = useCallback(() => {
    setAppliedFilters([]);
    dispatch(setFreightGridFilters({}));
    dispatch(getFreightGridRequest(FIRST_PAGE));
  }, [dispatch]);

  const resolvedFilterBys = useMemo(
    () =>
      allFilterBys.map((filterBy) => ({
        ...filterBy,
        displayName: filterBy.displayName(appliedFilters),
      })),
    [appliedFilters],
  );

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={resolvedFilterBys}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaArgumentsMap={staticCriteriaArguments}
        criteriaOperatorsMap={criteriaOperatorsMap}
        onFiltersChanged={onFiltersChanged}
        popularFilterBys={resolvedFilterBys}
        shouldUseOverflow={false}
        showOtherFilter={false}
      />
      <div className={style['filter-bar-actions-wrapper']} />
    </div>
  );
};
